<template>
  <nav id="navigation-container" class="navbar navbar-expand-lg navbar-light justify-content-between">
    <router-link :to="{ name: 'Home'}" class="navbar-brand"><img src="../../assets/images/header_image.png" height="100" width="168"></router-link>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" v-if="is_authenticated">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent" v-if="is_authenticated && ($route.path !== '/' || scoped_site_id === 1)">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
          <router-link :to="{ name: 'CalendarScheduler' }" class="nav-link">
            <img src="../../assets/images/nav_icons/scheduler.png" height="25" width="25">
            <span class="nav-text">Scheduler</span>
          </router-link>
        </li>
        <li class="nav-item dropdown" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
          <a class="nav-link dropdown-toggle" href="" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
            <img src="../../assets/images/nav_icons/zone_manager.png" height="25" width="25">
            <span class="nav-text">Zones</span>
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <router-link :to="{ name: 'ZoneManager' }" class="dropdown-item">Manager</router-link>
            <router-link :to="{ name: 'ZoneMap'}" class="dropdown-item">Map</router-link>
          </div>
        </li>
        <li class="nav-item" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
          <router-link :to="{ name: 'Devices' }" class="nav-link">
            <img src="../../assets/images/nav_icons/devices.png" height="25" width="25">
            <span class="nav-text">Devices</span>
          </router-link>
        </li>
        <li class="nav-item dropdown" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
          <a class="nav-link dropdown-toggle" href="" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
            <img src="../../assets/images/nav_icons/sounds.png" height="25" width="25">
            <span class="nav-text">Sounds</span>
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <router-link :to="{ name: 'SoundFilesIndex' }" class="dropdown-item">Files</router-link>
            <router-link :to="{ name: 'PlaylistsIndex' }" class="dropdown-item">Playlists</router-link>
          </div>
        </li>
        <li class="nav-item dropdown" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
          <router-link :to="{ name: 'ImageGallery' }" class="nav-link">
            <i class="fas fa-image nav-icon"></i>
            <span class="nav-text">Images</span>
          </router-link>
        </li>
        <li class="nav-item dropdown" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
          <router-link :to="{ name: 'Notifications' }" class="nav-link">
            <img src="../../assets/images/nav_icons/announcements.png" height="25" width="25">
            <span class="nav-text">Announcements</span>
          </router-link>
        </li>
        <li class="nav-item dropdown" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
          <router-link :to="{ name: 'AlertIndex' }" class="nav-link">
            <i class="fas fa-exclamation-triangle nav-icon"></i>
            <span class="nav-text">Alerts</span>
          </router-link>
        </li>
        <li class="nav-item dropdown" v-if="[2,3,4].includes(logged_in_user.group_id)">
          <router-link :to="{ name: 'AdminG2Secure' }" class="nav-link">
            <i class="fas fa-lock nav-icon"></i>
            <span class="nav-text">G2&nbsp;Secure</span>
          </router-link>
        </li>
        <li class="nav-item dropdown" v-if="[2,3,4].includes(logged_in_user.group_id)">
          <router-link :to="{ name: 'AdminDashboard' }" class="nav-link">
            <img src="../../assets/images/nav_icons/admin.png" height="25" width="25">
            <span class="nav-text">Admin</span>
          </router-link>
        </li>
        <li class="nav-item" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
          <a class="nav-link" href="http://help.g2com.online/">
            <img src="../../assets/images/nav_icons/training.png" height="25" width="25">
            <span class="nav-text">Help&nbsp;&&nbsp;Training</span>
          </a>
        </li>
      </ul>
      <div>
        <img :src="'./upload/images/site_logos/' + scoped_site_id + '.png'" :alt="'logo ' + scoped_site_id" width="100" height="100"><img>
      </div>
    </div>
    <div v-if="!is_authenticated">
      <img :src="'./upload/images/site_logos/' + scoped_site_id + '.png'" :alt="'logo ' + scoped_site_id" width="100" height="100"><img>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      is_authenticated: 'isAuthenticated',
      scoped_site_id: 'scopedSiteId',
      logged_in_user: 'loggedInUser'
    })
  }
}
</script>

<style scoped>
#navigation-container {
  background-color: #eee;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}

#navigation-container .navbar-nav {
  width: 100%;
  display: flex;
  justify-content: start;
  gap: 1rem;
}

#navigation-container .nav-link {
  display: flex;
  align-items: center;
  gap: 0.2rem;
}
#navigation-container .nav-icon {
  font-size: 25px;
  color: #032544;
}

#navigation-container .nav-text {
  font-size: 1rem;
  color: #032544;
}

@media screen and (max-width: 1590px) {
  #navigation-container .nav-text {
    font-size: 0.9rem;
  }

  #navigation-container .navbar-nav {
    gap: 0.1rem
  }
}

@media screen and (max-width: 1390px) {
  #navigation-container .nav-link {
    flex-direction: column;
  }

  #navigation-container .navbar-nav {
    justify-content: center;
  }
}

@media screen and (max-width: 1120px) {
  #navigation-container .nav-text {
    font-size: 0.75rem;
  }
}

@media screen and (max-width: 990px) {
  #navigation-container .nav-link {
    flex-direction: row;
    justify-content: start;
  }
  #navigation-container .navbar-nav {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>